import { Component, Output, EventEmitter } from '@angular/core';
import { Currency } from '@galaxy/billing';

@Component({
  selector: 'orders-currency-selector',
  templateUrl: './currency-selector.component.html',
  styleUrls: ['./currency-selector.component.scss'],
})
export class CurrencySelectorComponent {
  private _selectedCurrency = '';

  allCurrencies: string[];

  get selectedCurrency(): string {
    return this._selectedCurrency;
  }

  set selectedCurrency(curr: string) {
    this._selectedCurrency = curr;
    this.currencySelected.emit(curr);
  }

  @Output() currencySelected = new EventEmitter<string>();

  constructor() {
    this.allCurrencies = Object.keys(Currency).map((key) => Currency[key]);
  }
}
